import { getDataMapper, mapField } from "@/shared";

export const mapRentProductToServer = getDataMapper(
    {
        product_id: mapField("product", (p) => p.id),
        count: mapField("count", Number),
    },
    { shouldAvoidUndefined: true }
);
